export default __webpack_public_path__ + "static/media/Book-Keeper.1b60d025.png";